/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadgeAlt3S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.305.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 10l1.145 2.342a1 1 0 0 1-.43 1.323l-2.303 1.221-.45 2.568a1 1 0 0 1-1.125.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 17.906l-2.581.365a1 1 0 0 1-1.125-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 10 2.542 7.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 1.73l2.581.365zM9.555 11.85v1.33c.273.147.586.257.94.33.353.08.72.12 1.1.12.58 0 1.08-.097 1.5-.29a2.19 2.19 0 0 0 .98-.83c.226-.367.34-.8.34-1.3 0-.567-.177-1.037-.53-1.41-.347-.38-.844-.607-1.49-.68l1.72-1.76V6.33h-4.43V7.6h2.45l-1.8 1.9.49.82a2.84 2.84 0 0 1 1.02-.19c.38 0 .666.093.86.28.2.187.3.45.3.79 0 .36-.127.637-.38.83-.254.193-.617.29-1.09.29-.327 0-.67-.04-1.03-.12a3.97 3.97 0 0 1-.95-.35z" />
        <path d="m10.61 20.438-1.523-1.473L8 19.119v4.88l4-1.5 4 1.5v-4.88l-1.087-.154-1.522 1.473a2 2 0 0 1-2.782 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgBadgeAlt3S as BadgeAlt3S };
